import React from "react";
import { Col, Row } from "react-bootstrap";
import { SiNumpy, SiPandas, SiDbt, SiPowerbi, SiMicrosoftexcel } from "react-icons/si";

function DataScienceStack() {
    return (
        <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
            <Col xs={4} md={2} className="tech-icons">
                <SiPowerbi className="tech-icon-images" />
                <div className="tech-icons-text">Power BI</div>
            </Col>
            <Col xs={4} md={2} className="tech-icons">
                <SiPandas className="tech-icon-images" />
                <div className="tech-icons-text">Pandas</div>
            </Col>
            <Col xs={4} md={2} className="tech-icons">
                <SiNumpy className="tech-icon-images" />
                <div className="tech-icons-text">Numpy</div>
            </Col>
            <Col xs={4} md={2} className="tech-icons">
                <SiMicrosoftexcel className="tech-icon-images" />
                <div className="tech-icons-text">Excel</div>
            </Col>
            <Col xs={4} md={2} className="tech-icons">
                <SiDbt className="tech-icon-images" />
                <div className="tech-icons-text">DBT</div>
            </Col>
        </Row>
    );
}

export default DataScienceStack;
